import React, { useState } from 'react'
import { LayoutChangeEvent, StyleProp, StyleSheet, View, ViewStyle } from 'react-native'
import Svg, { Defs, LinearGradient, Rect, Stop } from 'react-native-svg'

interface GradientBorderProps {
  children: React.ReactNode
  borderWidth?: number
  borderRadius?: number
  style?: StyleProp<ViewStyle>
}

export const GradientBorder = ({
  children,
  borderWidth = 2,
  borderRadius = 16,
  style,
}: GradientBorderProps) => {
  const [size, setSize] = useState({ width: 0, height: 0 })

  const handleLayout = (e: LayoutChangeEvent) => {
    const { width, height } = e.nativeEvent.layout
    setSize((prev) => {
      if (prev.width === width && prev.height === height) {
        return prev
      }
      return { width, height }
    })
  }

  return (
    <View
      style={[{ borderRadius, padding: borderWidth, overflow: 'hidden' }, style]}
      onLayout={handleLayout}
    >
      <Svg style={StyleSheet.absoluteFill}>
        <Defs>
          <LinearGradient id="gradient-border" x1="0%" y1="0%" x2="100%" y2="0%">
            <Stop offset="9.53%" stopColor="#5ABAEE" />
            <Stop offset="44.85%" stopColor="#A9C09D" />
            <Stop offset="93.41%" stopColor="#EEC875" />
          </LinearGradient>
        </Defs>
        <Rect
          x="0"
          y="0"
          width={size.width}
          height={size.height}
          rx={borderRadius}
          ry={borderRadius}
          fill="url(#gradient-border)"
        />
      </Svg>
      {children}
    </View>
  )
}
